module.exports = __webpack_public_path__ + "static/media/lidcore-mockup-4.a67844db.jpg";